import { render, staticRenderFns } from "./readonlypartrow.vue?vue&type=template&id=5cd2b0b6&"
import script from "../../ts/readonlymode/readonlypartrow.ts?vue&type=script&lang=js&"
export * from "../../ts/readonlymode/readonlypartrow.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/readonlymode/readonlypartrow.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports